import React from 'react';
import PropTypes from 'prop-types';

import { Flex } from '@sopranodesign/pulse-components';

import General from './General';
import Bubble from './Bubble';

const Carousel = ({
  content,
  handleButtonClick,
  handleButtonLocationClick,
  direction,
  hasHadReply,
  rtl = 'ltr'
}) => (
  <Flex fat="true" xScroll xSpace>
    {content.items.map((item, key) => (
      <General
        rtl={rtl}
        dataTestid={`carousel-image-${key}`}
        key={key}
        type="carousel"
        direction={direction}
        content={item}
        handleButtonLocationClick={handleButtonLocationClick}
        handleButtonClick={handleButtonClick}
        hasHadReply={hasHadReply}
      />
    ))}
  </Flex>
);

Carousel.propTypes = {
  rtl: PropTypes.oneOf(['rtl', 'ltr']),
  content: PropTypes.shape({
    items: PropTypes.array.isRequired
  }).isRequired,
  direction: Bubble.propTypes.direction,
  handleButtonClick: PropTypes.func.isRequired,
  handleButtonLocationClick: PropTypes.func.isRequired,
  hasHadReply: PropTypes.bool
};

export default Carousel;
